module.exports = __webpack_public_path__ + "static/uni_kapor1-e11a791128bc15a0e24ce1e8ab23b95e.png";